'use strict'
 
// xdrService is used to make HTTP calls via IE8. the browser window object has
// an object called
// XDR that makes any http calls. all AJAX calls of our app are made via the XDR
// service
// rather than the $resource module
angular.module('cvsApp').factory (
            'xdrService',
            [
             '$rootScope',
             '$window',
             'errors',
             '$timeout',
             function ( $rootScope, $window, errors, $timeout ) {
                
                 function doXDRequest ( url, data, success, error ) {
                     var xdr = new $window.XDomainRequest();
                     var err = {response:{header:{statusCode:88888}}};
                     var exp = false;
                    
                     //console.log ( "start XDomainRequest created" );
                     $rootScope.showSpinner = true;
                     $timeout ( function (  ) {  
                         if (xdr) {
                             // Error Handler
                             xdr.onerror = function (  ) {
                                 //console.log ( "xdr error ==> " + xdr.responseText );
                                 $rootScope.$apply ( function ( ) {                                    
                                     error ( xdr.responseText );
                                     $rootScope.showSpinner = false;
                                 } );
                             }
 
                             // Success Handler
                             xdr.onload = function (  ) {
                                //console.log ( "xdr success" );
                                 // var x2js       = new X2JS ( );
                                 // var jsondata   = x2js.xml_str2json ( xdr.responseText );
                                 var jsondata = xdr.responseText 
                                
                                 $rootScope.$apply ( function ( ) {                                     
                                     /*if (jsondata.response.header.statusCode == "3004") {
                                         jsondata.response.header.statusDesc = errors.getErrorMessage ( "100" );                                               
                                         error ( jsondata );
                                     } else {*/
                                         success ( jsondata );
                                     /*}*/
                                     $rootScope.showSpinner = false;
                                 } );
                             }
                            
                             xdr.onprogress = function (  ) {
                                 //console.log ( "xdr onprogress " );
                             }
 
                             xdr.ontimeout = function (  ) {
                                 //console.log ( "xdr timeout " );
                             }                            
                             
                            
                             xdr.timeout = 0;
                             try {
                                 //console.log ( "xdr.open ==> " + url );
                                 xdr.open ( "POST", url );
                                 
                                 if ( !$rootScope.showSpinner ) {
                                     $rootScope.showSpinner = true;
                                 }
                                
                                 //console.log ( "xdr.send ==> " + data );
                                 xdr.send ( data );
                                
                             } catch ( e ) {
                                
                                 //console.log ('Exception: '+ e);
                                 $rootScope.$apply ( function (  ) {                                     
                                     error ( err );  
                                     $rootScope.showSpinner = false;
                                    
                                 } ); 
                             
                             }                             
                         }
                     }, 2000 );
                    
                 }
                
                 return {
                     makeRequest: doXDRequest
                 };
             } ] );